var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"gallery-row"},[_c('div',{staticClass:"gallery-container"},[_c('div',{staticClass:"d-none d-sm-block"},[_c('lightbox',{attrs:{"assets":_vm.assets}})],1),_c('GallerySlide',{staticClass:"d-flex d-sm-none",attrs:{"assets":_vm.assets}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }